<template>
  <div class="Psychometric-chat-status">
    <div class="des">心探陪聊状态</div>
    <div class="btn">
      <span
        @click="changeStatus(item)"
        v-for="item in list"
        :key="item.name"
        :class="{ active: item.statusList.includes(currentItem.status) }"
      >
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script>
import { xinTanChangeStatus } from 'api/platform/homepage.js'

export default {
  name: 'Psychometric-chat-status',

  props: {
    workStatus: {
      type: [Number, null],
      default: null
    },
    loginUser: {
      type: [Object, Array],
      default: () => ({})
    }
  },

  data() {
    return {
      // work_status 状态：0已休息，1服务中，2空闲
      list: [
        {
          name: '空闲',
          status: 2,
          statusList: [1, 2] // 如果状态是1，也需高亮
        },
        {
          name: '已休息',
          status: 0,
          statusList: [0]
        }
      ],
      currentItem: {}
    }
  },

  watch: {
    workStatus: {
      handler(val) {
        if (typeof val === 'number') {
          this.currentItem = this.genCurrentItem(val)
        }
      },
      immediate: true
    }
  },

  methods: {
    changeStatus(item) {
      if (item.status === this.currentItem.status) {
        return
      }
      const loading = this.$loading('处理中...')
      return xinTanChangeStatus({
        status: item.status,
        token: this.loginUser.token
      })
        .then(({ code, data, message }) => {
          if (code === 0) {
            this.currentItem = this.genCurrentItem(+data.work_status)
            this.$toast(message || '更新成功')
          } else {
            this.$toast(message || '更新失败')
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          loading && loading.close()
        })
    },
    genCurrentItem(val) {
      return this.list.find(v => v.statusList.includes(val)) || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.Psychometric-chat-status {
  width: 690px;
  height: 114px;
  background: #ffffff;
  margin: 0 auto 30px;
  padding: 0 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff;
  border-radius: 30px;
  .des {
    height: 37px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #21252d;
    line-height: 37px;
  }
  .btn {
    min-width: 210px;
    height: 54px;
    background: #f2f4ff;
    border-radius: 28px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      line-height: 37px;
      &.active {
        height: 54px;
        line-height: 54px;
        padding: 0 29px;
        background: #6982fa;
        border-radius: 28px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin: 0 !important;
        white-space: nowrap;
      }
      &:first-of-type {
        margin: 0 6px 0 16px;
      }
      &:last-of-type {
        margin: 0 16px 0 6px;
      }
    }
  }
}
</style>
